// ABOUTME: Play page — lists games the signed-in user is participating in as a player.
// ABOUTME: Responsive card grid with empty state; no Create Game CTA.
import { useState, useEffect } from 'react'
import { useAuth } from '@clerk/react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { GameCard } from '../components/GameCard'
import { Pagination } from '../components/Pagination'
import { gamePlayerActionsControllerGetGamesAsPlayer, type GameDto } from '../api/generated'

export function PlayPage() {
  const { getToken } = useAuth()
  const [games, setGames] = useState<GameDto[]>([])
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  useEffect(() => {
    async function load() {
      const token = await getToken()
      const res = await gamePlayerActionsControllerGetGamesAsPlayer(
        { page, limit: 50 },
        { headers: { Authorization: `Bearer ${token}` } },
      )
      if (res.status === 200) {
        setGames(res.data.items as unknown as GameDto[])
        setTotalPages(res.data.totalPages)
      }
    }
    load()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <Box pt={4}>
      <Typography variant="h4" component="h1" mb={3}>Play</Typography>
      {games.length === 0 ? (
        <Box textAlign="center" py={8}>
          <Typography color="text.secondary">
            You haven&apos;t been invited to any games yet.
          </Typography>
        </Box>
      ) : (
        <>
          <Grid container spacing={3}>
            {games.map((game) => (
              <Grid key={game.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <GameCard game={game} href={`/games/${game.id}/play`} />
              </Grid>
            ))}
          </Grid>
          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </Box>
  )
}
